import apiClient from '@/plugins/axios';

function toRoundHistoryUpdatePayload(roundHistory = {}) {
	return {
		userName: roundHistory.userName ?? null,
		done: roundHistory.done ?? null,
		name: roundHistory.name ?? null,
		description: roundHistory.description ?? null,
		lastSentEmail: roundHistory.lastSentEmail ?? null,
		userId: roundHistory.userId ?? null,
		roleId: roundHistory.roleId ?? null,
		customerId: roundHistory.customerId ?? null,
		roundPlanningId: roundHistory.roundPlanningId ?? null
	};
}

export default {
	getRoundHistories(params, opts = {}) {
	const langCode = localStorage.getItem('lang') || 'sv';
	params.langCode = langCode;
	params.pageNumber = params.currentPage;
	delete params['currentPage'];

	return apiClient.get('v1/RoundHistory', { params, ...opts });
},

	getRoundHistory(roundHistoryId) {
		const langCode = localStorage.getItem('lang') || 'sv';
		return apiClient.get(`v1/RoundHistory/${roundHistoryId}`, {
			params: { langCode }
		});
	},
	getAllRoundHistory(buildingId) {
		return apiClient.get(`v1/RoundHistory/GetAllRoundHistory/${buildingId}`);
	},


	createRoundHistory(roundHistory) {
		return apiClient.post('v1/RoundHistory', roundHistory);
	},

	updateRoundHistory(roundHistory) {
		var roundHistoryId = roundHistory.id;

		return apiClient.put(
			`v1/RoundHistory/${roundHistoryId}`,
			toRoundHistoryUpdatePayload(roundHistory)
		);
	},

	deleteRoundHistory(roundHistoryId) {
		return apiClient.delete(`v1/RoundHistory/${roundHistoryId}`);
	},

	getCompletedRoundHistories(params, opts = {}) {
		params.pageNumber = params.currentPage;
		delete params['currentPage'];

		return apiClient.get('v1/RoundHistory/GetCompletedRoundHistories', { params, ...opts });
	},

	getUnCompletedRoundHistories(params, opts = {}) {
		params.pageNumber = params.currentPage;
		delete params['currentPage'];

		return apiClient.get('v1/RoundHistory/GetUnCompletedRoundHistories', { params, ...opts });
	}
};
